<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'MaDictSelect',
})
</script>
<template>
	<el-select
		v-model="selectValue"
		:placeholder="placeholder"
		:filterable="filterable"
		:multiple="multiple"
		:disabled="disabled"
		:clearable="clearable"
		:allow-create="allowCreate"
		:default-first-option="allowCreate"
		@change="handleChange"
	>
		<el-option v-for="data in dataList" :key="data.dictValue" :label="data.dictLabel" :value="data.dictValue">{{ data.dictLabel }}</el-option>
	</el-select>
</template>

<script setup lang="ts" name="MaDictSelect">
import { getDictDataList } from '@/utils/tool'
import { useAppStore } from '@/store/modules/app'
import { computed } from 'vue'

const appStore = useAppStore()
const props = defineProps({
	dictType: {
		type: String,
		required: true
	},
	clearable: {
		type: Boolean,
		required: false,
		default: () => false
	},
	placeholder: {
		type: String,
		required: false,
		default: () => ''
	},
	filterable: {
		type: Boolean,
		required: false,
		default: true
	},
	multiple: {
		type: Boolean,
		required: false,
		default: false
	},
	disabled: {
		type: Boolean,
		required: false,
		default: false
	},
	allowCreate: {
		type: Boolean,
		required: false,
		default: false
	}
})

const model: any = defineModel<number | string | null>()
const emit = defineEmits(['change'])

// 处理null值的computed属性
const selectValue = computed({
	get() {
		return model.value === null || model.value === undefined || model.value === '' || model.value === 'null' ? undefined : model.value
	},
	set(value) {
		model.value = value === undefined ? null : value
	}
})

const handleChange = (e: any) => {
	emit('change', e)
}

// 将dataList改为计算属性，使其能够响应dictType的变化
const dataList = computed(() => {
	return getDictDataList(appStore.dictList, props.dictType)
})
</script>
